const firebaseConfig = {
         apiKey: "AIzaSyD3eclz58OeTpuOMOkorzPjRxNwH_HTMV0",
         authDomain: "edmart-9ec29.firebaseapp.com",
         projectId: "edmart-9ec29",
         storageBucket: "edmart-9ec29.appspot.com",
         messagingSenderId: "64563744568",
         appId: "1:64563744568:web:339e64e9dc07b97543fbcd"
       };
export default firebaseConfig;